"use strict";
/**
 * @package global-header.definition
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var component_definition_1 = require("@ingrooves/component-definition");
var google_tags_1 = __importDefault(require("@ingrooves/google-tags"));
var camelCase = require("lodash.camelcase");
var get = require("lodash.get");
var map = require("lodash.map");
var reduce = require("lodash.reduce");
var set = require("lodash.set");
var getType = function (topic) {
    return Object.prototype.toString.call(topic).slice(8, -1);
};
var isArray = function (topic) { return getType(topic) === "Array"; };
var _ = { map: map, reduce: reduce, isArray: isArray, set: set, get: get, camelCase: camelCase };
var requests = new Map();
var pushUser = function (props) { return __awaiter(_this, void 0, void 0, function () {
    var userId, accountId, attrs, dl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                userId = props && props.userId;
                accountId = props && props.tagManagerId;
                if (!accountId || !userId) {
                    return [2 /*return*/];
                }
                attrs = { accountId: accountId, userId: userId };
                if (!requests.get(accountId)) {
                    requests.set(accountId, google_tags_1.default.load(attrs));
                }
                return [4 /*yield*/, requests.get(accountId)];
            case 1:
                dl = _a.sent();
                if (userId && !requests.get(String(userId))) {
                    requests.set(String(userId), true);
                    dl.push({ user_id: userId });
                }
                return [2 /*return*/, dl];
        }
    });
}); };
var getUserThemeIdFromCookie = function () {
    try {
        var cookie = document.cookie.split(";").find(function (item) {
            return item.trim().indexOf("theme=") === 0;
        });
        return cookie && cookie.split("=")[1] || null;
    }
    catch (error) {
        return null;
    }
};
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this) || this;
        _this.props = [
            "activeProduct",
            "brandingClass",
            "changePasswordUrl",
            "dynamicLogoBaseUri",
            "languages",
            "loginUrl",
            "logoutUrl",
            "onLanguageClick",
            "onMenuClick",
            "opened",
            "navMenu",
            "publicPage",
            "productMenu",
            "signInLabel",
            "signInUrl",
            "tagManagerId",
            "userId",
            "userLanguageId",
            "userLanguageName",
            "userMenu",
            "userName",
            "userThemeId",
        ];
        _this.name = "global-header";
        _this.initialState = {
            dynamicLogoBaseUri: "https://logo.ingrooves.com",
            loginUrl: "/login",
            opened: false,
            userThemeId: getUserThemeIdFromCookie(),
        };
        _this.methods = {
            toggle: function (state) {
                return {
                    opened: !state.opened,
                };
            },
        };
        component_definition_1.assign(_this, props);
        _this.rename = _this.rename.bind(_this);
        _this.transform = _this.transform.bind(_this);
        return _this;
    }
    Header.prototype.mounted = function (_a) {
        var $ = _a.$;
        // closes any submenus when parent closes
        if ($ && $.fn && $.fn.dropdown) {
            var dropdown_1 = $("#global-header-component [data-toggle='dropdown']");
            dropdown_1.dropdown();
            dropdown_1.parent().on("hide.bs.dropdown", function () {
                dropdown_1.parent().find(".dropdown-sub").removeClass("open");
            });
        }
        if ($ && $.fn) {
            // toggles parent menu when toggle button is clicked
            var subMenuToggle_1 = $("#global-header-component .dropdown-sub > .dropdown-toggle");
            subMenuToggle_1.on("click", function (e) {
                subMenuToggle_1.closest(".dropdown").toggleClass("open");
                e.stopPropagation();
            });
            var userDropdown = $("#global-header-component .navbar-user [data-toggle='dropdown']");
            // collapse navbar-toggle on submenu item click
            userDropdown.parent().on("show.bs.dropdown", function () {
                var subMenu = subMenuToggle_1.next(".dropdown-menu");
                subMenu.on("click", function () {
                    subMenu.closest(".collapse").removeClass("in");
                });
            });
        }
    };
    Header.prototype.beforeDestroy = function (_a) {
        var $ = _a.$;
        if ($ && $.fn && $.fn.dropdown) {
            $("#global-header-component [data-toggle='dropdown']").dropdown("destroy");
        }
    };
    Header.prototype.created = function (props) {
        pushUser(props);
    };
    Header.prototype.updated = function (__, currentProps) {
        pushUser(currentProps);
    };
    /* Transforms navMenu, productMenu, and userMenu */
    Header.prototype.transform = function (props) {
        var changePasswordUrl = props.changePasswordUrl, logoutUrl = props.logoutUrl, languageSelectCallback = props.languageSelectCallback, tagManagerId = props.tagManagerId;
        var userLanguageId = _.get(props, "userMenu.user.language") || "";
        var languages = _.get(props, "userMenu.languages") || [];
        var userLanguageName = _.get(languages.find(function (lang) {
            return lang.id === userLanguageId.toLowerCase();
        }), "name") || "";
        var onLanguageClick = languageSelectCallback
            ? function (e) {
                if (languageSelectCallback) {
                    languageSelectCallback({ id: e.target.dataset.id });
                }
            }
            : null;
        var navMenu = _.get(props, "navMenu");
        var helpMenu = _.get(props, "helpMenu");
        if (helpMenu) {
            helpMenu.id = "help";
            navMenu.push(helpMenu);
        }
        var result = {
            languages: languages,
            navMenu: this.menuTransform(navMenu),
            onLanguageClick: onLanguageClick,
            productMenu: this.productMenuTransform(_.get(props, "productMenu"), props.activeProduct),
            publicPage: props.publicPage || false,
            signInLabel: _.get(props, "signIn.label") || "",
            signInUrl: this.getSignInUrl(props),
            tagManagerId: tagManagerId,
            userId: _.get(props, "userMenu.user.userId") || _.get(props, "userId") || "",
            userLanguageId: userLanguageId,
            userLanguageName: userLanguageName,
            userMenu: this.userMenuTransform({
                changePasswordUrl: changePasswordUrl,
                logoutUrl: logoutUrl,
                userMenu: _.get(props, "userMenu") || [],
            }),
            userName: _.get(props, "userMenu.user.name") || _.get(props, "userMenu.user.email") || _.get(props, "userName") || "",
            userThemeId: this.getUserThemeId(props),
        };
        return result;
    };
    Header.prototype.getSignInUrl = function (props) {
        return (props.signInUrl ||
            "" + (_.get(props, "signIn.host") || "") + (_.get(props, "signIn.pathname") || ""));
    };
    /* Gets the user theme from explicit prop, menu (user metadata), or cookie */
    Header.prototype.getUserThemeId = function (props) {
        var theme;
        var prop = _.get(props, "userThemeId");
        var metadata = _.get(props, "userMenu.user.theme");
        var cookie = getUserThemeIdFromCookie();
        if (typeof prop === "string") {
            theme = prop;
        }
        else if (typeof metadata === "string") {
            theme = metadata;
        }
        else {
            theme = cookie || "";
        }
        return theme;
    };
    /* Transform the nav menu */
    Header.prototype.menuTransform = function (navMenu) {
        if (!navMenu) {
            return [];
        }
        return _.map(navMenu, this.rename);
    };
    /* Transforms the product menu */
    Header.prototype.productMenuTransform = function (productMenu, activeProduct) {
        if (!productMenu) {
            return [];
        }
        productMenu.forEach(function (item, index) {
            var product = _.get(item, "id") || "";
            _.set(item, "key", "" + _.camelCase(product) + index);
        });
        var mapped = _.map(productMenu, this.rename);
        /* Remove the active product */
        mapped = mapped.filter(function (item) {
            return _.get(item, "id") !== activeProduct;
        });
        return mapped;
    };
    /* Transforms the user menu */
    Header.prototype.userMenuTransform = function (userMenuProps) {
        var userMenu = _.get(userMenuProps, "userMenu");
        if (!userMenu) {
            return [];
        }
        var propMap = {
            changePassword: "changePasswordUrl",
            signOut: "logoutUrl",
        };
        // replace the menu item pathname with the provided URL prop
        userMenu.children = _.map(userMenu.children, function (item) {
            var id = _.get(item, "id");
            if (id && (id in propMap)) {
                item.pathname = _.get(userMenuProps, "" + propMap[id]) || "";
            }
            return item;
        });
        return _.map(userMenu.children, this.rename);
    };
    Header.prototype.rename = function (obj, index) {
        var _this = this;
        var result = Object.assign({}, obj);
        _.map(obj, function (value, key) {
            if (_.isArray(value)) {
                value = _.map(value, _this.rename);
            }
            _.set(result, _.camelCase(key), value);
        });
        _.set(result, "href", "" + (_.get(result, "host") || "") + (_.get(result, "pathname") || ""));
        var label = _.get(result, "label") || "";
        _.set(result, "key", _.get(result, "key") || "" + _.camelCase(label) + index);
        Object.defineProperty(result, "active", {
            get: function () {
                return (typeof window !== "undefined" &&
                    _.get(result, "href") === _.get(window, "location.href"));
            },
        });
        _.set(result, "active", typeof window !== "undefined" &&
            _.get(result, "active") === _.get(window, "location.href"));
        return result;
    };
    return Header;
}(component_definition_1.Component));
exports.Header = Header;
